import { render, staticRenderFns } from "./ClosuresBody.vue?vue&type=template&id=6012364a&scoped=true&"
import script from "./ClosuresBody.vue?vue&type=script&lang=ts&"
export * from "./ClosuresBody.vue?vue&type=script&lang=ts&"
import style0 from "./ClosuresBody.vue?vue&type=style&index=0&id=6012364a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6012364a",
  null
  
)

export default component.exports